// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1f8cE","rightAdornment":"Header_rightAdornment__ky3KJ"};